// Which department a per-department page (Phones, System) is acting on (portal-phones-ux).
// "All departments" is not a real scope on these pages -- they fall back to the admin's home
// department. Before this banner that fallback was silent, so an admin could edit their own
// department's settings while believing they were looking at "all".

import { useQuery } from '@tanstack/react-query';
import { Building2 } from 'lucide-react';
import { api } from '../lib/api';
import { useActiveTenant } from '../lib/tenantScope';
import { describeScope } from '../lib/portalUx';

export default function ScopeBanner({ what = 'This page' }: { what?: string }) {
  const me = api.me();
  const canScope = me?.role === 'super_admin' || me?.role === 'reseller';
  const active = useActiveTenant();
  // Same query key as the Layout's department selector, so this is served from cache.
  const { data: depts } = useQuery({ queryKey: ['dept-scope-list'], queryFn: () => api.tenants.list(), enabled: canScope });
  if (!canScope) return null;
  const s = describeScope({ activeTenant: active, homeDomain: me?.domain_uuid, depts: depts as any[] });
  return (
    <div className={`text-sm rounded-md border px-3 py-2 flex items-start gap-2 ${s.fallback ? 'border-warning/60 bg-warning/10' : 'border-border bg-elevated'}`}>
      <Building2 size={15} className="mt-0.5 shrink-0 text-textSecondary" />
      {s.fallback ? (
        <span>
          <strong>All departments</strong> is selected, but {what.toLowerCase()} works on one department at a time,
          so it is showing your home department{ s.label ? <> (<strong>{s.label}</strong>)</> : null }.
          Pick a department in the <em>Viewing</em> selector above to work on another one.
        </span>
      ) : (
        <span>Department: <strong>{s.label || 'unknown'}</strong></span>
      )}
    </div>
  );
}
